import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import Portrait from '@blade-sxp/task-management/components/portrait.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import { getTaskDetail, postTask, updateTask } from '@blade-sxp/task-management/api/creat-task/index';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import ConfidenceBox from '@blade-sxp/task-management/components/confidence.vue';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
// 人脸比对、人脸&人体联合
let FaceVehicleTask = class FaceVehicleTask extends Vue {
    loading = true;
    isDetail = false;
    isReady = false;
    isError = false;
    disableRight = false;
    id = '';
    type = 'add';
    taskType = 'ROAD_DEFECTION_DETECT';
    name = '';
    status = 'ENABLE';
    portraitId = '';
    level = 'CRITICAL';
    threshold = 10;
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    filterable = true;
    idealList = [
        { type: this.$t('potholeConfidence'), value: 66, codeType: 'potholeConfidence' },
        { type: this.$t('alligatorConfidence'), value: 66, codeType: 'alligatorConfidence' },
        { type: this.$t('ravelingConfidence'), value: 66, codeType: 'ravelingConfidence' },
        { type: this.$t('linearConfidence'), value: 66, codeType: 'linearConfidence' },
        { type: this.$t('subsidenceConfidence'), value: 66, codeType: 'subsidenceConfidence' },
    ];
    roadDefectDetectThreshold = {};
    titleList = {
        leftTitle: this.$t('taskType'),
        rightTitle: this.$t('confidence'),
    };
    remark = '';
    get formData() {
        const { name, portraitId, threshold, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, idealList } = this;
        return {
            name,
            portraitId,
            threshold,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            idealList,
        };
    }
    init() {
        this.clearData();
        const { type, id, taskType } = this.$route.query;
        if (!type) {
            this.$message.error(`${this.$t('common.unknownError')}`);
        }
        this.type = type;
        this.id = id;
        this.taskType = taskType;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    async validForm(val) {
        if (this.isDetail) {
            return;
        }
        for (let i = 1; i <= 5; i++) {
            if (this.$refs['formItem' + i]) {
                let res = await this.$refs['formItem' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        const res = val.idealList.find((item) => {
            return item.value === '';
        });
        if (res?.value === '') {
            this.disableRight = true;
            return;
        }
        this.disableRight = false;
    }
    clearData() {
        this.loading = true;
        this.isDetail = false;
        this.isReady = false;
        this.isError = false;
        this.disableRight = true;
        this.id = '';
        this.type = 'add';
        this.taskType = 'ROAD_DEFECTION_DETECT';
        this.name = '';
        this.status = 'ENABLE';
        this.portraitId = '';
        this.level = 'CRITICAL';
        this.threshold = 10;
        this.effectivePeriod = 'PERMANENT';
        this.effectiveDates = {
            start: '',
            end: '',
        };
        this.effectiveTimes = [{ start: '', end: '' }];
        this.dayOfWeeks = [];
        this.idealList = [
            { type: this.$t('potholeConfidence'), value: 66, codeType: 'potholeConfidence' },
            { type: this.$t('alligatorConfidence'), value: 66, codeType: 'alligatorConfidence' },
            { type: this.$t('ravelingConfidence'), value: 66, codeType: 'ravelingConfidence' },
            { type: this.$t('linearConfidence'), value: 66, codeType: 'linearConfidence' },
            { type: this.$t('subsidenceConfidence'), value: 66, codeType: 'subsidenceConfidence' },
        ];
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const countUnitEnum = 'PERCENT';
        this.idealList.map((item) => {
            this.roadDefectDetectThreshold[`${item.codeType}`] = { countUnitEnum: countUnitEnum, value: item.value };
        });
        const req = {
            taskName: this.name,
            remark: this.remark,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'SECOND',
                        value: this.threshold,
                    },
                },
                thresholdConfigs: [
                    {
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        effectivePeriod: this.effectivePeriod,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : effectiveTimes,
                        roadDefectDetectThreshold: this.roadDefectDetectThreshold,
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            postTask(req).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            updateTask({ taskId: this.id, ...req }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    getData() {
        getTaskDetail(Number(this.id)).then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                this.threshold = notifyConfig?.frequency?.value;
                this.level = notifyConfig?.enabledAlarmLevels[0];
            }
            let arr = [];
            const list = deviceTaskConfigs[0].roadDefectDetectConfig.roadDefectDetectThreshold;
            for (let key in list) {
                arr.push({
                    type: `${this.$t(key)}`,
                    value: list[key].value,
                    codeType: key,
                });
            }
            this.idealList = arr;
            if (!isEmpty(deviceTaskConfigs)) {
                deviceTaskConfigs.forEach((item) => {
                    const roiData = item.roiData;
                    if (!isEmpty(roiData)) {
                        const analysis = JSON.parse(roiData);
                        DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                    }
                });
            }
            this.loading = false;
        });
    }
    fromDataDeviceConfig() {
        const config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let persons = [];
                let rawRoi = [];
                let directions = [];
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'DIRECTION') {
                            item.data.forEach((item) => {
                                directions = item.vertices;
                            });
                        }
                        if (item.type === 'BODY') {
                            item.data.forEach((item) => {
                                let pern = {
                                    x: item.vertices[0].y > item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                    y: item.vertices[0].y < item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                };
                                persons.push(pern);
                            });
                        }
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                rawRoi.push({
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                });
                            });
                        }
                    });
                }
                let data = {
                    roadDefectDetectConfig: {
                        directions: directions,
                        roiMappings: rawRoi,
                    },
                    labelPersons: persons,
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], FaceVehicleTask.prototype, "init", null);
__decorate([
    Watch('formData', { deep: true })
], FaceVehicleTask.prototype, "validForm", null);
FaceVehicleTask = __decorate([
    Component({
        name: 'FaceBodyTask',
        components: {
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            portrait: Portrait,
            'alarm-level': AlarmLevel,
            'frequency-threshold': FrequencyAndThreshold,
            'button-box': ButtonBox,
            'st-device-darwer': DeviceDarwer,
            'confidence-box': ConfidenceBox,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    alert: 'Alert Notification',
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    detection: 'Road detection',
                    potholeConfidence: 'Potholes',
                    alligatorConfidence: 'Alligator Crack',
                    ravelingConfidence: 'Loose',
                    linearConfidence: 'Linear Crack',
                    subsidenceConfidence: 'Subsidence',
                    confidence: 'Confidence',
                    taskType: 'Type',
                },
                zh: {
                    alert: '告警通知',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    detection: '道路检测',
                    potholeConfidence: '坑槽',
                    linearConfidence: '裂缝',
                    ravelingConfidence: '松散',
                    alligatorConfidence: '龟裂',
                    subsidenceConfidence: '沉降',
                    confidence: '置信度',
                    taskType: '类型',
                },
            },
        },
    })
], FaceVehicleTask);
export default FaceVehicleTask;
